import { useEffect, useRef } from 'react'
import { ClipboardPaste, Sparkles } from 'lucide-react'

export default function TerminalContextMenu({
  x,
  y,
  onClose,
  onPaste,
  onSendToAI,
  hasSelection,
}) {
  const menuRef = useRef(null)

  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose()
      }
    }
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', handleKey)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleKey)
    }
  }, [onClose])

  const menuStyle = {
    position: 'fixed',
    left: x,
    top: y,
    zIndex: 9999,
  }

  return (
    <div
      ref={menuRef}
      style={menuStyle}
      className="min-w-[180px] rounded-lg border border-slate-600/80 bg-slate-800 py-1 shadow-xl"
    >
      <button
        onClick={() => {
          onPaste()
          onClose()
        }}
        className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-slate-200 hover:bg-slate-700/80"
      >
        <ClipboardPaste className="h-4 w-4 text-slate-400" />
        Colar
      </button>

      {hasSelection && (
        <button
          onClick={() => {
            onSendToAI()
            onClose()
          }}
          className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-slate-200 hover:bg-slate-700/80"
        >
          <Sparkles className="h-4 w-4 text-theme-primary" />
          Enviar ao Agente AI
        </button>
      )}
    </div>
  )
}
